import React, { FC } from 'react';
import { Button } from '@design-system/button';
import { Image } from '@design-system/image';

import { ICustomTab } from './models';

const CustomTab: FC<ICustomTab> = ({ button, image, handleSetActiveTab }) => (
  <div className="custom-tabs__item">
    <Image src={image.src} alt={image.altText} className="custom-tabs__item-image" />
    <Button
      variant="secondary"
      size="small"
      className="custom-tabs__item-button"
      aria-label={button.ariaLabel}
      onClick={handleSetActiveTab}
    >
      {button.label}
    </Button>
  </div>
);

export default CustomTab;
